import { Alert } from "antd";
import { useEffect, useState } from "react";
import '../distributer/distributer.css';
import { listUserType } from "../../api/login/Login";

function KycDetailsFilter({ setPage, submitForm, setFilterKey, fetchKycList, isVerified }) {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '+91',
        email: '',
        refer_id: '',
        user_type_id: '',
    });
    const [userTypes, setUserTypes] = useState([]);
    const [error, setError] = useState('');
    const [isSearchDisabled, setIsSearchDisabled] = useState(false);

    useEffect(() => {
        const fetchUserTypes = async () => {
            try {
                const res = await listUserType();
                if (res && (res.data || Array.isArray(res))) {
                    const list = Array.isArray(res.data) ? res.data : (Array.isArray(res) ? res : []);
                    setUserTypes(list);
                }
            } catch (err) {
                console.error("Failed to load user types:", err);
            }
        };
        fetchUserTypes();
    }, []);

    useEffect(() => {
        setFormData({
            name: '',
            mobile: '+91',
            email: '',
            refer_id: '',
            user_type_id: '',
        });
        setError('');
        setIsSearchDisabled(false);
    }, [isVerified]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        let newValue = value;

        if (!newValue.startsWith('+91')) {
            newValue = '+91' + newValue.replace('+91', '');
        }

        newValue = '+91' + newValue.slice(3).replace(/\D/g, '');
        newValue = newValue.slice(0, 13);

        const mobileRegex = /^\+91\d{10}$/;
        if (newValue !== '+91' && newValue !== '' && !mobileRegex.test(newValue)) {
            setError('Invalid mobile number. Please enter a 10-digit number after +91.');
            setIsSearchDisabled(true);
        } else {
            setError('');
            setIsSearchDisabled(false);
        }

        setFormData((prevData) => ({ ...prevData, mobile: newValue }));
    };

    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (error) return;
        submitForm(formData);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    const resetForm = () => {
        setFilterKey(null);
        setFormData({
            name: '',
            mobile: '+91',
            email: '',
            refer_id: '',
            user_type_id: '',
        });
        setError('');
        setIsSearchDisabled(false);
        setPage(0);
        fetchKycList(0, null);
    };

    return (
        <div className="row member-filter-wrapper" style={{ margin: "2px 16px 2px 16px" }}>
            <div className="col-xl-12" style={{ padding: "0" }}>
                <div className="card" style={{ marginBottom: "0" }}>
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1" style={{ overflow: "visible" }}>
                            <div className="tbl-caption tbl-caption-2" style={{ padding: "4px 16px", minHeight: "unset", borderBottom: "1px solid #f0f0f0" }}>
                                <h4 className="heading mb-0" style={{ fontSize: "13px", margin: 0, padding: 0 }}>
                                    <b>Filter {isVerified ? "Verified Users" : "Not Verified Users"}</b>
                                </h4>
                            </div>
                            <form className="row cusforms" style={{ padding: "6px 16px 2px 16px" }} onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder="Enter name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="mobile"
                                        placeholder="Enter 10-digit mobile number"
                                        value={formData.mobile}
                                        onChange={handlePhoneChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        placeholder="Enter email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="refer_id"
                                        placeholder="Enter ref id"
                                        value={formData.refer_id}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <div className="form-group col-4">
                                    <select
                                        className="form-control"
                                        id="user_type_id"
                                        value={formData.user_type_id}
                                        onChange={handleChange}
                                        onKeyDown={handleKeyDown}
                                    >
                                        <option value="">All Member Types</option>
                                        {userTypes?.map((ut) => (
                                            <option key={ut._id} value={ut._id}>
                                                {ut.user_type || ut.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group col-12">
                                    {error ? (<Alert message="Warning" description={error} type="warning" showIcon closable />) : ""}
                                </div>
                                <div className="form-group col-12 btn-action-group">
                                    <button type="submit" className="btn btn-primary" disabled={isSearchDisabled}>
                                        SEARCH
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                        RESET
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default KycDetailsFilter;

